import { render, staticRenderFns } from "./studentModal.vue?vue&type=template&id=8a35e0fe&scoped=true&"
import script from "./studentModal.vue?vue&type=script&lang=js&"
export * from "./studentModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a35e0fe",
  null
  
)

export default component.exports